import _ from "underscore";
import React, { useCallback } from "react";
import { connect } from "../../utils/aj-react";
import { getDefaultState, PriorityStore } from "../../stores/priority";
import { clearPriorities, loadItems, reorderItems } from "../../actions/priority";
import { optional, uuid } from "../../utils/lang";
import ScrollableList from "./scrollableList";
import { isNotEmpty, isEmpty} from "../../framework/utils";
import { MaterialIcon } from "./materialIcon";
import { changeOnBlur } from "./mobile/forms";
import * as CustomUtils from "../../utils/customUtils";

export default class PriorityControl extends React.Component {
    constructor(props) {
        super(props);
        this.uuid = uuid();
        
        if (isEmpty(this.props.entity)) {
            throw new Error("PriorityControl: entity is not defined");
        }

        /*if (!isEmpty(this.props.entity) && isEmpty(this.props.level)) {
            throw new Error("PriorityControl: level is not defined");
        }*/

        connect(this, PriorityStore, getDefaultState());
    }

    componentDidMount() {
        loadItems({
            entity: this.props.entity,
            level: this.props.level,
            parent: this.props.parent,
        });
    }

    componentWillUnmount() {
        clearPriorities();
    }

    onChange(reorderedItems) {
        reorderItems({items: reorderedItems});
    }

    onListChange(_items) {
        const ids = _.pluck(optional(_items, []), "id"),
            items = optional(this.state.items, []),
            reorderedItems = [];

        _.each(ids, id => reorderedItems.push(_.findWhere(items, {id: id})));

        this.onChange(reorderedItems);
    }

    onIndexChange(oldIndex, value){          
        const newIndex = value;
        if(newIndex != ""){
            const items = CustomUtils.arrayMoveImmutable(this.state.items, oldIndex, newIndex);
            this.onChange(items);
        }        
        
        
    }

    render() {
        const items = _.map(optional(this.state.items, []), (item, index) => {
            const OnBlurInput = changeOnBlur("input");
            
            return {
                id: item.id,
                content: (<div
                        key={"priority-control-" + this.uuid + "-item-" + index}
                        className="priority-control__list-item"
                    >
                            <div className="priority-control__list-item-icon">
                                <MaterialIcon icon = "drag_indicator"/>
                            </div>
                            <OnBlurInput className = "priority-control__list-item-number"
                                type = "text"
                                value = {index}
                                onChange = {(e) => this.onIndexChange(index, e.target.value)}
                            />
                            <div>
                                {item.description}
                            </div>
                        </div>),
            };
        })
        return(
            <div className="priority-control">
                <ScrollableList
                    items={items}
                    onChange={this.onListChange.bind(this)}
                />
            </div>
        )
    }
}